<template lang="pug">
.fill-height(v-if="isLoaded")
  splitpanes.default-theme(@resized="onResized" :style="{'height':`${height}px`, 'background-color':'#CCCCCC'}" )
    pane(:size="28")
      geofence-table(:height="height" :key="$store.state.geofence.geofenceTableKey")
    pane(:size="72")
      geofence-map(:style="{'height':`${height-20}px`, 'width':'100%'}" :height="height" :key="track_key")
</template>

<script>
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css'
import GeofenceMap from "@/modules/maps/components/maps/GeofenceMap";
import GeofenceTable from "@/modules/maps/components/ui/Tables/GeofenceTable";


export default {
  components:{
    Splitpanes,
    Pane,
    GeofenceMap,
    GeofenceTable
  },

  data: () => ({
    height: null,
    track_key:1,
    isLoaded:false,
  }),

  mounted() {
    this.isLoaded = false;
      this.$store.dispatch("contacts/loadAllContacts").then(()=> {
        this.$store.dispatch("vehicles/loadAllItems").then(() => {
          this.$store.dispatch("geofence/loadAllGeofences").then(() => {
            this.isLoaded = true;
            console.log(this.$store.state.geofence.geofence_data)
          })
        })
      })







  },

  methods: {
    onResized:function(){
      this.track_key++;
    },
    onResize:function(){
      this.height = window.innerHeight - 110;
    }
  },

  created() {
    // stretch the elements to fill the height
    this.height = window.innerHeight - 110;
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
}
</script>

<style scoped lang="stylus">

</style>